import '../scss/main.scss';
import 'tether-select/dist/css/select-theme-default.css';

import './scroll';
import {initScrollDown} from './scroll-down';
import {screenHeightToBlockHeight} from './height';
import {initModalWindows} from './modal';
import {initSelect} from './select';
import {setWidthEqualToTarget} from './helpers';
import {initFocusInput} from './input';
import {AttachFormEventListener, RemoveEmptyPTags} from './form';
import {initSidebarModal} from './sidebar';

initModalWindows();
initScrollDown();
screenHeightToBlockHeight();
initSelect();
initFocusInput();
setWidthEqualToTarget('.select-target', '.select-content');
AttachFormEventListener();
RemoveEmptyPTags();
initSidebarModal();

jQuery( window ).resize(function() {
    setWidthEqualToTarget('.select-target', '.select-content');
});

jQuery( window ).load(function() {
    jQuery("#preloader").fadeOut(500);
});